import { Link } from 'react-router-dom'
import img1 from '../images/about-1-copyright.jpg'

function HowToPlay() {
	return (
		<>
<section class="hero_area htp_area" style={{background:`URL(${img1})`}}>
		<div class="container">
			<div class="hero_cnt">
				<div class="hero_title">
					<h2>How to Play Fantasy Cricket</h2>
					<h1> How to Play Fantasy Cricket on BlueLakeEscapesFI</h1>
				</div>
			</div>
		</div>
	</section>

	<section class="sec_2_htp">
		<div class="container">
			<div class="s2_htp_cnt">
				<p>Welcome to the How to Play page of BlueLakeEscapesFI! Whether you’re a seasoned fantasy cricket player or new to the game, this guide will walk you through the essential steps to get started, from registration to building your ultimate team.</p>
				<h3>Step 1: Registration</h3>
				<p>To embark on your fantasy cricket journey, you first need to register on our platform. Follow these simple steps:</p>
				<ol>
					<li>Visit Our Homepage: Go to the BlueLakeEscapesFI homepage.</li>
					<li>Get App Link Button: Look for the “Get App Link” button prominently displayed on the main page.</li>
					<li>Enter Your Phone Number: Click the button and enter your mobile phone number in the provided field.</li>
					<li>Receive the App Link: After entering your phone number, click the “Get App Link” button. A modal window will appear, displaying the message:
						“Expect your Fantasy App Link on your phone number.”</li>
					<li>Check Your Messages: You will receive a link to download the Wicket Dreams Fantasy app directly to your phone.</li>
				</ol>
				<h3>Step 2: Download the App</h3>
				<p>Once you receive the link, follow these steps to download the app:</p>
				<ul>
					<li>Click on the link sent to your phone.</li>
					<li>Follow the prompts to install the app on your device.</li>
				</ul>
				<h3>Step 3: Create Your Fantasy Team</h3>
				<p>After installing the app, follow these steps to create your fantasy cricket team:</p>
				<ol>
					<li>Log In: Open the app and log in using your registered phone number.</li>
					<li>Select Players: Choose your players based on their current form, statistics, and upcoming matches. The better your players perform in real matches, the more points you earn!</li>
					<li>Stay Updated: Monitor player performances and adjust your team as needed.</li>
				</ol>
				<h3>Step 4: Compete and Win</h3>
				<p>Now that your team is set up, participate in various leagues and tournaments:</p>
				<ul>
					<li>Join public or private leagues.</li>
					<li>Compete with friends or players from around the world.</li>
					<li>Track your progress through live scoring and updates.</li>
				</ul>
				<p>Enjoy the Game!</p>
				<p>At BlueLakeEscapesFI, we encourage fair play and strategic thinking. Get ready to showcase your cricketing skills and compete for amazing prizes!</p>
				<p>If you have any questions or need assistance, feel free to reach out to our support team.</p>
			</div>
		</div>
	</section>


		</>
	)
}

export default HowToPlay
